module.exports = __webpack_public_path__ + "img/recruit_btn.cd6f8273.png";